import ActionTypes from '../constants/ActionTypes';
import { supo, locationApi } from '../api';

export const fetchLocation = id => {
  return async dispatch => {
    try {
      const { data: location } = await supo.get(`/location/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_SUCCESS,
        payload: location
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchLocationToPostcode = param => {
  return async dispatch => {
    try {
      const { data } = await locationApi.get(param);
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_TO_POSTCODE_SUCCESS,
        payload: data[0].postcode
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_LOCATION_TO_POSTCODE_ERROR,
        payload: { param }
      });
    }
  };
};
